export default __webpack_public_path__ + "static/media/a028-6.1969a309.png";